var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCareHistoryVagInfectionVisit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 23
    },
    viewBox: "0 0 27 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.306 10.318a6.916 6.916 0 0 1-10.797 0 .444.444 0 0 0-.694.556 7.803 7.803 0 0 0 5.648 2.914v8.22a.445.445 0 0 0 .89 0v-8.22A7.806 7.806 0 0 0 20 10.874a.445.445 0 0 0-.695-.556ZM23.757 1.235a26.306 26.306 0 0 1-.809 20.585.445.445 0 0 0 .804.38A27.185 27.185 0 0 0 24.588.92a.444.444 0 0 0-.831.315ZM4.868 21.82A26.298 26.298 0 0 1 4.06 1.235.445.445 0 0 0 3.228.92 27.19 27.19 0 0 0 4.063 22.2a.445.445 0 0 0 .805-.38Z",
    fill: "#B760FF",
    stroke: "#B760FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCareHistoryVagInfectionVisit);
export default __webpack_public_path__ + "static/media/icon_care_history_vag_infection_visit.5e0bf270f91c3607876859feef567012.svg";
export { ForwardRef as ReactComponent };